import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { PrivacyPage } from "@/components/pages/PrivacyPage";
import { en } from "@/i18n/en";

export const Route = createFileRoute("/en/privacy")({
  head: () =>
    buildHead({
      lang: "en",
      page: "home",
      title: en.privacy.page.title + " · 2AM Hospitality",
      description: en.privacy.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "en") i18n.changeLanguage("en");
    }, []);
    if (i18n.language !== "en") i18n.changeLanguage("en");
    return <PrivacyPage />;
  },
});
